<template>
    <section class="body">
        <ExportDialog @ok="selectExportMode" :dialogId="exportDialogId" getter="getAdsExportQuery" setter="setAdsExportQuery" />
        <ExportDialogReport :dialogId="exportDialogReportId" :tableViewModes="tableViewModes" />
        <div v-if="adInitStatus == 'LOADING'">
            <div v-if="loadingFormData" class="text-center mb-2">
                <b-progress :value="loadingFormDataValue" show-progress class="m-5" />
            </div>
        </div>
        <div class="failedRequest" v-if="adInitStatus == 'FAILED'">
            Cannot return result due to a server error.
        </div>
        <div v-if="adInitStatus == 'LOADED'">
            <b-form>
                <b-form-row class="justify-content-center">
                    <DateModalAd
                        :fieldData="formFields.date"
                        :latestDate="$store.getters.getPublishedToDate"
                        @onInputChanged="inputChanged"
                        @onGetBuyingAgenciesAdvertisersProducts="getBuyingAgenciesAdvertisersProducts"
                    />
                    <ProviderPickerProgramsAdsModal :fieldData="formFields.providers" getter="getAdsQuery" providersSetter="setAdsQueryProviders" setter="setAdsQuery" />
                    <TargetGroupAds getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" v-bind:fieldData="formFields.target_group" />
                    <FilmcodePicker getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" :fieldData="formFields.filmCode" />
                    <ProductAdvertiserAgencyModal getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" v-bind:form="formFields" />
                    <FilmTypeBubble getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" v-bind:fieldData="formFields.spot_types" />
                    <ProductClassBubble getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" :fieldData="formFields.productClass" />
                    <CheckboxDropdownColumns getter="getAdsQuery" setter="setAdsQuery" @onInputChanged="inputChanged" v-bind:fieldData="columnsField" />
                </b-form-row>
                <b-form-row class="mb-2 justify-content-center">
                    <button v-if="getSelectedInputs > 0" type="button" class="trashbtn mt-2 mr-2" @click="clearAllFields">
                        <b-icon-trash />
                    </button>
                    <div v-for="(selectedButton, key) in selectedBtns" :key="key">
                        <button class="selectedbtns mr-2 mt-2 bubblefontsize" type="button" @click="selectedButton.clickedBtn && selectedButton.clickedBtn()">
                            <span v-html="selectedButton.text" />
                            <b-icon
                                v-if="selectedButton.editable"
                                class="ml-2 crossbtn"
                                font-scale="1.5"
                                icon="x"
                                @click="selectedButton.clickedBtnDelete && selectedButton.clickedBtnDelete($event)"
                            />
                        </button>
                    </div>
                </b-form-row>
            </b-form>
            <div v-if="!TargetGroupExists">
                <div class="text-center mb-2">
                    <div>
                        <small class="text-danger"><strong>You must select a target group under Target Groups / Measures.</strong></small>
                    </div>
                </div>
            </div>
            <b-form-row class="mb-2 justify-content-center">
                <div>
                    <b-button :disabled="disableRunBtn" @click="submitSearch" class="searchbutton" variant="primary" size="sm">
                        <font-awesome-icon v-if="status != 'LOADING'" style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'play']" />
                        {{ status === "LOADING" ? "Working..." : "Run" }}
                    </b-button>
                </div>
            </b-form-row>
            <div v-if="exceededConsumptionPeriodLimit">
                <div class="text-center mb-2">
                    <div>
                        <small class="text-danger"
                            ><strong>You can select a maximum of {{ config_NumberOfConsumptionDaysAd }} days as consumption period.</strong></small
                        >
                    </div>
                </div>
            </div>

            <ConfirmDialog dialogTitle="Recommendation for analyses" :dialogMessage="messageExceededRecommendedPeriod" :dialogId="exceededRecommendedPeriodDialogId" :dialogVerticalCenter="true">
                <template v-slot:modal-footer>
                    <b-button size="sm" variant="outline-secondary" @click="$bvModal.hide(exceededRecommendedPeriodDialogId)">
                        Cancel
                    </b-button>
                    <b-button size="sm" variant="primary" @click="acceptExceededRecommendedPeriod">
                        Ok
                    </b-button>
                </template>
            </ConfirmDialog>
            <ConfirmDialog
                dialogTitle="Search period over different model versions"
                :dialogMessage="messagePeriodOverlappingModelVersions"
                :dialogId="periodOverlappingModelVersionsDialogId"
                :dialogVerticalCenter="true"
            >
                <template v-slot:modal-footer>
                    <b-button size="sm" variant="primary" @click="$bvModal.hide(periodOverlappingModelVersionsDialogId)">
                        Back
                    </b-button>
                </template>
            </ConfirmDialog>
        </div>
        <hr />

        <b-tabs content-class="mt-3" v-model="tabIndex" @activate-tab="handleTabActivation">
            <b-tab title="Lista">
                <Spinner v-if="status == 'LOADING'" loadingMsg="Loading results..." />
                <div v-else-if="status == 'EMPTY_RESULT'">
                    Found nothing for current search
                </div>
                <div v-else-if="status == 'LOADED'">
                    <ResultTableMainAd />
                </div>
                <div class="failedRequest" v-else-if="status == 'FAILED'">
                    Cannot return result due to a server error.
                </div>
                <div v-else-if="status == 'VALIDATION_FAILED'" class="text-danger">
                    <span v-bind:key="index" v-for="(error, index) in formErrors" class="d-block">
                        {{ error }}
                    </span>
                </div>
            </b-tab>
            <b-tab v-if="config_ShowReachFrequencyAd" :title="rofTabTitle" :disabled="!this.$store.getters.getAdsHaveSelectedRow || !TargetGroupExists">
                <AdReach :exceededRecommendedPeriodLimit="exceededRecommendedPeriodLimit" :loadRofTab="loadRofTab" @setLoadRofTabBool="setLoadRofTabBool"></AdReach>
            </b-tab>
            <b-tab v-if="config_ShowCampaignReportAd" title="Campaign Report" :disabled="status !== 'LOADED' || !this.$store.getters.getAdsHaveSelectedRow">
                <!-- <Spinner v-if="statusCampaignReport == 'LOADING'" loadingMsg="Laddar kampanjrapport..." /> -->
                <div v-if="statusCampaignReport == 'EMPTY_RESULT'">
                    Found nothing for current search
                </div>
                <div>
                    <ReportAd :tableViewModes="tableViewModes" />
                </div>
                <div class="failedRequest" v-if="statusCampaignReport == 'FAILED'">
                    Cannot return result due to a server error.
                </div>
                <div v-else-if="statusCampaignReport == 'VALIDATION_FAILED'" class="text-danger">
                    <span v-bind:key="index" v-for="(error, index) in formErrors" class="d-block">
                        {{ error }}
                    </span>
                </div>
            </b-tab>
            <template v-slot:tabs-end>
                <div class="ml-auto">
                    <b-button class="mb-2 align-baseline mr-2" size="sm" variant="primary" @click="showOrHideSumInTable" :disabled="disableSumBtn" v-if="showSumBtn"
                        >{{ sumVisible ? "Hide summary" : "Show summary" }}
                    </b-button>
                    <b-button
                        class="ml-auto"
                        size="sm"
                        variant="success"
                        v-if="status === 'LOADED' && tabName === 'list'"
                        @click="$bvModal.show(exportDialogId)"
                        v-b-tooltip.hover
                        :disabled="loadingExportResults"
                        title="Export the result on screen"
                    >
                        <font-awesome-icon style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'file-export']" />
                        {{ loadingExportResults ? "Working" : "Export" }}
                    </b-button>
                    <b-button
                        class="ml-auto"
                        size="sm"
                        variant="success"
                        v-else-if="statusRof === 'LOADED' && tabName === 'rof'"
                        @click="exportRofResult"
                        v-b-tooltip.hover
                        title="Export the result on screen"
                    >
                        <font-awesome-icon style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'file-export']" />
                        Export
                    </b-button>
                    <b-button
                        class="ml-auto"
                        size="sm"
                        variant="success"
                        v-else-if="statusCampaignReport === 'LOADED' && tabName === 'report'"
                        @click="$bvModal.show(exportDialogReportId)"
                        :disabled="!allSumModesLoaded"
                    >
                        {{ !allSumModesLoaded ? "Fetching all view modes" : "Export" }}
                        <b-spinner v-if="!allSumModesLoaded" small></b-spinner>
                    </b-button>
                </div>
            </template>
            <SlowQueryModal :show="showSlowQueryModal" :loading="loadingExportResults" @download="handleDownloadSlowQueryModal" @cancel="handleCancelSlowQueryModal" />
            <ScheduleReportModal :show="showScheduleReportModal" :loading="loadingScheduleReport" @submit="handleScheduleReportSubmit" @cancel="handleScheduleReportCancel" />
        </b-tabs>
    </section>
</template>

<script>
import SlowQueryModal from "../../Shared/SlowQueryModal/SlowQueryModal.vue"
import ScheduleReportModal from "../../Shared/ScheduleReportModal/ScheduleReportModal.vue"
import DateModalAd from "./DateModalAd"
import AdReach from "@/components/Layout/Ads/AdReach"
import Spinner from "@/components/Shared/Spinner/Spinner"
import CheckboxDropdownColumns from "../../Shared/FormElement/CheckboxDropdown/CheckboxDropdownColumns"
import TargetGroupAds from "../../Shared/FormElement/TargetGroup/TargetGroupAds"
import { baseFields } from "./formData"
import { validationRules } from "./adValidationRules"
import inputValidation from "@/mixins/inputValidation"
import props from "@/mixins/inputProps"
import { mapState } from "vuex"
import * as Actions from "@/store/modules/ads/action-types"
import * as Mutations from "@/store/modules/ads/mutation-types"
import dayjs from "dayjs"
import { download, dateToyymmddFormat, scrollToBottom, daysBetweenDates } from "../../../api/utils.js"
import ResultTableMainAd from "@/components/Layout/Ads/ResultTableMainAd"
import ReportAd from "@/components/Layout/Ads/ReportAd/ReportAd"
import ExportDialog from "@/components/Shared/FormElement/Dialogs/ExportDialog"
import ExportDialogReport from "@/components/Shared/FormElement/Dialogs/ExportDialogReport"
import globalConfig from "../../../mixins/globalConfig"
import ConfirmDialog from "@/components/Shared/FormElement/Dialogs/ConfirmDialog"
import { MeasureSumMode } from "@/constants/appConstants"
import ProviderPickerProgramsAdsModal from "../../Layout/Programs/ProviderPickerProgramsAdsModal.vue"
import FilmcodePicker from "@/components/Shared/FormElement/InputMulti/FilmcodePicker"
import ProductAdvertiserAgencyModal from "./ProductAdvertiserAgencyModal"
import FilmTypeBubble from "@/components/Shared/FormElement/CheckboxDropdown/FilmTypeBubble"
import ProductClassBubble from "./ProductClassModal"

export default {
    name: "Ads",
    components: {
        SlowQueryModal,
        ScheduleReportModal,
        DateModalAd,
        AdReach,
        CheckboxDropdownColumns,
        Spinner,
        ResultTableMainAd,
        ExportDialog,
        ExportDialogReport,
        ConfirmDialog,
        ReportAd,
        ProviderPickerProgramsAdsModal,
        FilmcodePicker,
        ProductAdvertiserAgencyModal,
        TargetGroupAds,
        FilmTypeBubble,
        ProductClassBubble,
    },
    mixins: [inputValidation, props, globalConfig],
    beforeDestroy() {
        document.removeEventListener("keyup", this.onKeyUp)
    },
    data() {
        return {
            showScheduleReportModal: false,
            loadingScheduleReport: false,
            loadingExportResults: false,
            showSlowQueryModal: false,
            filterRatingIsChecked: false,
            loadingFormData: true,
            loadingFormDataValue: 0,
            step: 0,
            formFields: baseFields,
            columnsField: {
                config: { options: [] },
                identifier: "columns",
                label: "Show columns",
            },
            selectAll: false,
            hasFetchedBuyingAgenciesAdvertisersProducts: false,
            isAdDataLoaded: false,
            tabName: "list",
            exportDialogId: "ads-export-modal",
            exportDialogReportId: "ads-export-report-modal",
            targetLabel: "",
            message: "",
            formErrors: [],
            targetGroupRequiredText: false,
            tabIndex: 0,
            exceededRecommendedPeriodDialogId: "exceeded-recommended-period",
            hasAcceptedExceededPeriod: false,
            messageExceededRecommendedPeriod: "",
            clickedTabIndex: "0",
            periodOverlappingModelVersionsDialogId: "period-overlapping-model-versions",
            loadRofTab: false,
            checkForFieldChanges: false,
            selectedBtns: [],
        }
    },
    watch: {
        "$store.getters.getAdsQueryCost.data"(queryData) {
            // visa modal
            if (queryData.queryClass == "RowLimitExceeded") {
                this.showSlowQueryModal = true
            }
            if (queryData.queryClass == "Schedule") {
                this.showScheduleReportModal = true
            }
            if (queryData.queryClass == "Forbidden") {
                this.$bvToast.toast("The execution is too demanding, limit the search or remove target groups.", {
                    title: "Server error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            }
        },
        "$store.getters.getPublishedToDate"(publishedToDate) {
            this.setStartAndEndDate(publishedToDate)
        },
        "$store.getters.getAdsQuery": {
            deep: true,
            handler(query) {
                let selectedBtns = []
                selectedBtns.push({
                    text: `<span class="font-weight-bold">Consumption date:</span> ${query.startDate} - ${query.endDate}`,
                    editable: false,
                    clickedBtn: () => {
                        this.formFields.date.showDateModal = true
                    },
                })
                if (query.providerKeys.length > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Channels:</span> ${query.providerKeys.length} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.providers.showChannelModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.providerKeys = []
                        },
                    })
                }
                let numberOfStoredTargets = this.getTargetGroupCount()
                if (numberOfStoredTargets > 0) {
                    let chosenText = numberOfStoredTargets > 1 ? "selected" : "selected"
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">  Target / Metric </span> ${numberOfStoredTargets} ${chosenText}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.target_group.showTargetGroupModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.removeTargets()
                        },
                    })
                }
                if (query.filmCode.length > 0) {
                    let chosenText = query.filmCode.length > 0 ? "selected" : "selected"
                    let filmcodeText = `<span class="font-weight-bold">Film codes:</span> ${query.filmCode.length} ${chosenText}`
                    selectedBtns.push({
                        text: filmcodeText,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.filmCode.showFilmCodeModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            let updatedQuery = {
                                ...this.$store.getters["getAdsQuery"],
                                filmCode: [],
                            }
                            this.$store.commit("setAdsQuery", updatedQuery)
                        },
                    })
                }
                if (query.buyingAgencies) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold"> Agency </span> ${query.buyingAgencies.label}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.productAdvertiserAgency.showProductAdvertiserAgencyModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.buyingAgencies = null
                        },
                    })
                }
                if (query.advertisers) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold"> Advertiser </span> ${query.advertisers.label}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.productAdvertiserAgency.showProductAdvertiserAgencyModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.advertisers = null
                        },
                    })
                }
                if (query.products) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold"> Product </span> ${query.products.label}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.productAdvertiserAgency.showProductAdvertiserAgencyModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.products = null
                        },
                    })
                }
                    
                if (query.spot_types && query.spot_types.length > 0) {
                    let spotTypesText = query.spot_types.map(value => {
                    const match = this.formFields.spot_types.config.options.find(
                        obj => obj.value === value
                    );
                    return match ? match.text : null; // Return text if found, otherwise null
                    });
                    selectedBtns.push({
                    text: `<span class="font-weight-bold"> Film type: </span> ${spotTypesText.join(
                        ", "
                    )}`,
                    editable: true,
                    clickedBtn: () => {
                        this.formFields.spot_types.showSpotTypesModal = true;
                    },
                    clickedBtnDelete: event => {
                        event.stopPropagation();
                        this.query.spot_types = null;
                    }
                    });
                }
                if (query.productClasses && query.productClasses.length > 0) {
                    let chosenText = "selected";
                    selectedBtns.push({
                    text: `<span class="font-weight-bold"> Product class: </span> ${query.productClasses.length} ${chosenText}`,
                    editable: true,
                    clickedBtn: () => {
                        this.formFields.productClass.showProductClassModal = true;
                    },
                    clickedBtnDelete: event => {
                        event.stopPropagation();
                        this.query.productClasses = [];
                    }
                    });
                }
                this.selectedBtns = selectedBtns
            },
        },
        tabIndex(newVal) {
            if (newVal === 0) {
                this.hasAcceptedExceededPeriod = false
            }
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.init()
        let customParseFormat = require("dayjs/plugin/customParseFormat")
        dayjs.extend(customParseFormat)
    },
    updated() {
        let adsQuery = this.$store.getters.getAdsQuery
        if (adsQuery.startDate && adsQuery.endDate && !this.isAdDataLoaded) {
            this.getBuyingAgenciesAdvertisersProducts()
            this.isAdDataLoaded = true
        }
    },
    computed: {
        sumVisible() {
            let sumVisible = false
            if (this.status === "LOADED") {
                sumVisible = this.$store.getters.getAdsSumVisible
            }
            return sumVisible
        },
        disableSumBtn() {
            let disableSumBtn = false
            if (this.$store.getters.getAdsHasExcludedRow) disableSumBtn = true
            return disableSumBtn
        },
        showSumBtn() {
            let showSumBtn = false
            if (this.$store.getters.getAdsResults.status == "LOADED" && this.tabName === "list") {
                showSumBtn = true
            }
            return showSumBtn
        },
        allModalsClosed() {
            let allModalsClosed = false
            if (
                !this.formFields.date.showDateModal &&
                !this.formFields.providers.showChannelModal &&
                !this.formFields.target_group.showTargetGroupModal &&
                !this.formFields.filmCode.showFilmCodeModal &&
                !this.formFields.productAdvertiserAgency.showProductAdvertiserAgencyModal &&
                !this.formFields.spot_types.showSpotTypesModal &&
                !this.formFields.productClass.showProductClassModal
            )
                allModalsClosed = true
            return allModalsClosed
        },
        getSelectedInputs() {
            let selectedInputs = this.selectedBtns.length
            return selectedInputs
        },
        rofTabTitle() {
            let rofTabTitle = "Reach and frequency"
            if (!this.TargetGroupExists) rofTabTitle += " (target group must be specified)"
            return rofTabTitle
        },
        tableViewModes() {
            return Object.values(MeasureSumMode)
        },
        allSumModesLoaded() {
            let reportData = { ...this.$store.getters.getAdsCampaignReportResults.data }
            reportData = this.deletePropsNotInArray(
                reportData,
                this.tableViewModes.map(tvm => tvm.key)
            )
            return Object.values(reportData).every(vm => vm.status === "LOADED")
        },
        disableRunBtn() {
            let disableRunBtn = false
            if (this.status == "LOADING" || this.$store.getters.getAdsQuery.columns.length == 0 || !this.TargetGroupExists) disableRunBtn = true
            return disableRunBtn
        },
        TargetGroupExists() {
            let targetGroups = this.$store.getters.getAdsQuery.target_group

            return targetGroups != null && targetGroups.length > 0 ? true : false
        },
        status() {
            return this.$store.getters.getAdsResults.status
        },
        statusRof() {
            return this.$store.getters.getAdsRoFResults.status
        },
        // some state from vuex
        ...mapState({
            adInitStatus: ({ ads }) => ads.adsInitStatus,
            query: ({ ads }) => ads.adsQuery,
            queryForAPI: ({ ads }) => ads.adsQueryForAPI,
        }),
        statusCampaignReport() {
            return this.$store.getters.getAdsCampaignReportResults.status
        },
        exceededConsumptionPeriodLimit() {
            const maxDays = this.config_NumberOfConsumptionDaysAd - 1
            let period = daysBetweenDates(this.$store.getters.getAdsQuery.startDate, this.$store.getters.getAdsQuery.endDate)
            return period > maxDays
        },
        exceededRecommendedPeriodLimit() {
            let exceededRecommendedPeriodLimit = false
            if (this.config_NumberOfConsumptionDaysAd > this.config_NumberOfConsumptionDaysRecommendedAd && this.$store.getters.getAdsResults.status === "LOADED") {
                let chosenAdsDates = this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds.filter(s => s.chosen).map(s => s.date)
                if (chosenAdsDates.length > 0) {
                    const dayjsDates = chosenAdsDates.map(date => dayjs(date))
                    dayjsDates.sort((a, b) => a - b)
                    const lowestDate = dayjsDates[0]
                    const highestDate = dayjsDates[dayjsDates.length - 1]
                    let period = daysBetweenDates(lowestDate, highestDate)
                    const maxDays = this.config_NumberOfConsumptionDaysRecommendedAd - 1
                    return period > maxDays
                }
            }
            return exceededRecommendedPeriodLimit
        },
        messagePeriodOverlappingModelVersions() {
            return `Selected period overlaps different model versions of MMS Total which is not allowed. Selected search period must not overlap the date ${this.config_ToV3ChangeDate}.`
        },
        activeTabs() {
            let tabs = [
                { title: "list", condition: true },
                { title: "rof", condition: this.config_ShowReachFrequencyAd },
                { title: "report", condition: this.config_ShowCampaignReportAd },
            ]
            return tabs.filter(tab => tab.condition)
        },
    },
    methods: {
        async showOrHideSumInTable() {
            this.$store.commit(Mutations.setAdsSumVisible, !this.$store.getters.getAdsSumVisible)
        },
        removeTargets() {
            const updatedQuery = {
                ...this.$store.getters.getAdsQuery,
                target_group: [],
            }
            this.$store.commit("setAdsQuery", updatedQuery)
        },
        getTargetGroupCount() {
            return this.query.target_group != null ? this.query.target_group.length : 0
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.allModalsClosed) {
                this.onEnter()
            }
        },
        async handleDownloadSlowQueryModal() {
            this.$bvModal.show(this.exportDialogId)
            this.showSlowQueryModal = false
        },
        handleCancelSlowQueryModal() {
            this.showSlowQueryModal = false
        },

        async updateFilterRatingState() {
            // commit change to vuex
            const query = {
                ...this.$store.getters.getAdsQuery,
                filterByRating: this.filterRatingIsChecked,
            }
            await this.$store.commit(Mutations.setAdsQuery, query)
        },
        setLoadRofTabBool(loadRofTab) {
            this.loadRofTab = loadRofTab
        },
        deletePropsNotInArray(obj, allowedProps) {
            for (let prop in obj) {
                if (!allowedProps.includes(prop)) {
                    delete obj[prop]
                }
            }
            return obj
        },
        selectExportMode() {
            let fileName = ""
            let isResult = this.status === "LOADED"
            let startEndDateText = ""
            if (isResult) startEndDateText = `${this.queryForAPI.startDate}_${this.queryForAPI.endDate}`
            else startEndDateText = `${this.query.startDate}_${this.query.endDate}`
            if (!this.$store.getters.getExcelExportFilePreName) {
                fileName = `CROSS-PLATFORM_Advertising_${startEndDateText}`
            } else {
                fileName = `${this.$store.getters.getExcelExportFilePreName} CROSS-PLATFORM_Advertising_${startEndDateText}`
            }
            if (this.tabName === "list") {
                this.exportResult(`${fileName}.csv`)
            }
        },
        async exportResult(fileName) {
            try {
                this.loadingExportResults = true
                let query = {
                    ...this.$store.getters.getAdsExportQuery,
                    sortBy: this.mainSortBy,
                    sortByDesc: this.mainSortDesc,
                }
                this.$store.commit(Mutations.setAdsExportQuery, query)
                var exportToCsv = await this.$store.dispatch(Actions.executeAdsExportQuery, { tab: this.tabName, messageExceededRecommendedPeriod: "" })

                this.loadingExportResults = false
                download(exportToCsv, fileName, null)
            } catch (error) {
                this.loadingExportResults = false
            }

            /* gamla frontend exporten
            createExportAdList(this.$store.getters, {
                fileName: fileName,
                itemsToExport: this.$store.getters.getAdsResults,
                tab: this.tabName,
            })
            */
        },
        async handleScheduleReportSubmit(reportname) {
            this.loadingScheduleReport = true
            try {
                const options = { tab: this.tabName, messageExceededRecommendedPeriod: "", reportname: reportname }
                await this.$store.dispatch(Actions.executeScheduleQuery, options)

                this.$bvToast.toast("The execution is scheduled, you will receive an email when it's ready.", {
                    title: "Scheduled execution",
                    variant: "success",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } catch (error) {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
                this.$bvToast.toast("Could not schedule the report execution", {
                    title: "Serverfel",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } finally {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
            }
        },
        handleScheduleReportCancel() {
            this.showScheduleReportModal = false
        },
        exportRofResult() {
            this.$store.dispatch(Actions.executeAdsRoFExport)
        },
        handleTabActivation(newTabIndex, prevTabIndex, bvEvent) {
            this.tabIndex = newTabIndex
            const newTabTitle = this.getTabTitleByIndex(newTabIndex)

            if (!newTabTitle) {
                console.error("Attempted to activate a tab that does not exist.")
                return
            }
            this.clickedTabName = newTabTitle

            if ((newTabTitle === "rof" || newTabTitle === "report") && this.exceededRecommendedPeriodLimit && !this.hasAcceptedExceededPeriod) {
                bvEvent.preventDefault()
                this.$bvModal.show(this.exceededRecommendedPeriodDialogId)
                let startDateForApi = this.$store.getters.getAdsQueryForAPI.startDate
                let newEndDate = dayjs(startDateForApi)
                    .add(this.config_NumberOfConsumptionDaysRecommendedAd - 1, "d")
                    .format("YYYY-MM-DD")
                this.messageExceededRecommendedPeriod = `
                                        Selected period exceeds the maximum limit
                ${this.config_NumberOfConsumptionDaysRecommendedAd} days for <br> reach & frequency.
                Click OK if you want to proceed and adjust the period to the following: ${startDateForApi} - ${newEndDate}`
                return
            }

            this.tabName = newTabTitle
            switch (newTabTitle) {
                case "rof":
                    this.loadRofTab = true
                    break
                case "report":
                    this.fetchAdsCampaignReport()
                    break
            }
        },
        async acceptExceededRecommendedPeriod() {
            this.hasAcceptedExceededPeriod = true
            this.tabIndex = 1
            this.$bvModal.hide(this.exceededRecommendedPeriodDialogId)

            const clickedTabTitle = this.getTabTitleByIndex(this.clickedTabIndex)
            let startDateForApi = this.$store.getters.getAdsQueryForAPI.startDate
            let newEndDate = dayjs(startDateForApi)
                .add(this.config_NumberOfConsumptionDaysRecommendedAd - 1, "d")
                .format("YYYY-MM-DD")
            this.$store.commit(Mutations.setAdsEnddate, newEndDate)
            if (clickedTabTitle === "report") {
                await this.fetchAdsCampaignReport()
            }

            this.tabName = clickedTabTitle
            this.clickedTabIndex = null
        },
        async fetchAdsCampaignReport() {
            const reportTabIndex = this.findTabIndexByTitle("report")

            if (reportTabIndex !== -1) {
                this.tabIndex = reportTabIndex
                this.tabName = "report"

                await this.$store.dispatch(Actions.executeAdsCampaignReportQuery, { measureSumModeKey: MeasureSumMode.DAY.key, initialize: true })

                // Get campaign report header R&F here, for each target group
                try {
                    const targetGroups = this.query.target_group
                    const targetGroupLabels = targetGroups.map(targetGroup => targetGroup.selectedMeasureText.subHeader.split(" ")[0])

                    let RoFMeasuresArray = []
                    const queryBase = {
                        startDate: this.$store.getters.getAdsCampaignReportQuery.startDate,
                        endDate: this.$store.getters.getAdsCampaignReportQuery.endDate,
                        rowKeys: this.$store.getters.getAdsCampaignReportQuery.rowKeys,
                        aggregationType: "cumulative",
                        maxFreq: 10,
                    }
                    for (let targetGroup of targetGroupLabels) {
                        this.$store.commit(Mutations.setAdsRoFQuery, {
                            ...queryBase,
                            targetGroup: targetGroup,
                            measureType: "relative",
                        })

                        await this.$store.dispatch(Actions.executeAdsRoFQuery)
                        let relativeReachRoF = this.$store.getters.getAdsRoFResults.data.reach1PlusAcc.pop().replace(".", ",")

                        this.$store.commit(Mutations.setAdsRoFQuery, {
                            ...queryBase,
                            targetGroup: targetGroup,
                            measureType: "absolute",
                        })

                        await this.$store.dispatch(Actions.executeAdsRoFQuery)
                        let absoluteReachRoF = this.$store.getters.getAdsRoFResults.data.reach1PlusAcc.pop().replace(/\s+/g, "")

                        RoFMeasuresArray.push({
                            targetGroup: targetGroup,
                            measures: {
                                relativeReach: relativeReachRoF,
                                absoluteReach: absoluteReachRoF,
                            },
                        })
                    }
                    const payload = {
                        ...this.$store.getters.getAdsCampaignReportResults,
                        data: {
                            ...this.$store.getters.getAdsCampaignReportResults.data,
                            RoF: {
                                rofMeasures: RoFMeasuresArray,
                                status: "LOADED",
                            },
                        },
                    }

                    await this.$store.commit(Mutations.setAdsCampaignReportResults, payload)
                } catch (error) {
                    console.error("Could not get R&F data for the campaign report", error)
                    this.$store.commit(Mutations.setAdsCampaignReportResults, {
                        data: {
                            RoF: {
                                rofMeasures: [],
                                status: "FAILED",
                            },
                        },
                    })
                }

                // Continue loading the rest of the MeasureSumModes
                await this.$store.dispatch(Actions.executeAdsCampaignReportQuery, { measureSumModeKey: MeasureSumMode.PROVIDER.key, initialize: false })
                await this.$store.dispatch(Actions.executeAdsCampaignReportQuery, { measureSumModeKey: MeasureSumMode.FILMCODE.key, initialize: false })
                await this.$store.dispatch(Actions.executeAdsCampaignReportQuery, { measureSumModeKey: MeasureSumMode.WEEK.key, initialize: false })
            } else {
                console.error("Report data not found")
            }
        },

        clearAllFields() {
            let systemToDate = new Date(this.$store.getters.getMetadataAdToDate)
            this.query.endDate = dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate()))
            this.query.startDate = dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate()))
            this.query.filmCode = []
            this.query.buyingAgencies = null
            this.query.advertisers = null
            this.query.products = null
            this.query.providerKeys = []
            this.query.target_group = []
            this.query.spot_types = []
            this.query.columns = this.$store.getters.getAdsDefaultColumns
        },
        async init() {
            // many calls with side effects, start with actions
            try {
                const productClasses = await this.$store.dispatch(
                    Actions.getAdsProductClasses
                );
                this.formFields.productClass.config = productClasses;
                document.addEventListener("keyup", this.onKeyUp)
                this.checkForFieldChanges = true
                await this.$store.commit(Mutations.setAdsInitStatus, "LOADING")
                const measures = await this.$store.dispatch(Actions.getAdsMeasures)
                this.loadingFormDataValue = 25

                this.formFields.target_group.config.measures = [...measures]
                this.loadingFormDataValue = 50

                this.setStartAndEndDate(this.$store.getters.getPublishedToDate)
                await this.$store.dispatch(Actions.getAdsProviders)
                const newFields = {
                    ...this.formFields,
                    providers: { ...this.formFields.providers, ...this.$store.getters.getAdsProviders },
                }

                this.loadingFormDataValue = 75
                const columns = await this.$store.dispatch(Actions.getAdsColumnTypes)
                this.loadingFormDataValue = 100
                this.columnsField.config.options = [...columns]
                await this.$store.commit(Mutations.setAdsColumnTypes, columns)
                await this.$store.commit(
                    Mutations.setAdsDefaultColumns,
                    columns.filter(c => c.default_selection).map(c => c.value)
                )
                let updatedQuery = {
                    ...this.$store.getters["getAdsQuery"],
                    ["columns"]: this.$store.getters.getAdsDefaultColumns,
                }
                this.$store.commit("setAdsQuery", updatedQuery)
                            // important with await for vue to update our components
            // status must be = LOADED for them to be displayed and they refresh when we set formFields,
            // if they are not displayed then they don't refresh...
                await this.$store.commit(Mutations.setAdsInitStatus, "LOADED")
                this.formFields = newFields
                if(!this.$store.getters.getAdsHasSetDefaultQuery) {
                    this.$store.commit(Mutations.setAdsQueryDefault, updatedQuery);
                    this.$store.commit(Mutations.setAdsHasSetDefaultQuery, true);
                }
                this.loadingFormData = false
            } catch (error) {
                await this.$store.commit(Mutations.setAdsInitStatus, "FAILED")
            }
        },
        async submitSearch() {
            this.$store.commit(Mutations.setAdsSumVisible, false)
            this.tabIndex = 0
            this.tabName = "list"
            this.hasAcceptedExceededPeriod = false
            this.selectAll = false
            if (!this.TargetGroupExists || this.exceededConsumptionPeriodLimit) return
            validationRules(this)
            const hasError = this.validateForm()
            if (hasError) {
                scrollToBottom()
                this.$store.commit(Mutations.setAdsResults, {
                    status: "VALIDATION_FAILED",
                })
                if (this.formFields?.date?.startDate?.hasError || this.formFields?.date?.endDate?.hasError) {
                    this.formErrors.push("Please fill in consumption start date and consumption end date correctly.")
                }
                return
            }
            this.$store.commit("setAdsHaveSelectedRow", false)
            this.tabName = "list"
            try {
                await this.$store.dispatch(Actions.executeAdsQuery)
                this.checkForFieldChanges = true
                this.$store.commit(Mutations.setAdsQueryBeforeChange, this.query)
                this.$store.commit(Mutations.setAdsStringForFilterBeforeChange, this.displayStringForFilter)
                this.$store.commit(Mutations.setAdsHasExcludedRow, false)
            } catch (err) {
                this.$store.commit(Mutations.setAdsResults, {
                    status: "FAILED",
                })
            }
        },
        setStartAndEndDate(publishedToDate) {
            if (!publishedToDate) return
            let previousDate = this.$store.getters.getAdsQuery

            //only set endate to defaultdate when endate is not changed
            if (!previousDate.endDate) this.$store.commit(Mutations.setAdsEnddate, this.$store.getters.getMetadataAdToDate)
            if (!previousDate.startDate) {
                let startDate = new Date(this.$store.getters.getMetadataAdToDate)
                this.$store.commit(Mutations.setAdsStartdate, dateToyymmddFormat(startDate.setDate(startDate.getDate())))
            }
        },
        async getBuyingAgenciesAdvertisersProducts() {
            if (!this.hasFetchedBuyingAgenciesAdvertisersProducts) {
                this.hasFetchedBuyingAgenciesAdvertisersProducts = true
                let buyingAgencies = await this.$store.dispatch(Actions.getAdsBuyingAgencies)
                let advertisers = await this.$store.dispatch(Actions.getAdsAdvertisers)
                let products = await this.$store.dispatch(Actions.getAdsProducts)

                // check for invalid selections and clear them
                let updatedQuery = { ...this.$store.getters["getAdsQuery"] }
                // check for invalid product selection
                const selectedProductID = this.$store.getters.getAdsQuery?.products?.id
                let productExists = selectedProductID ? products?.some(item => item.id === selectedProductID) : false
                if (!productExists) {
                    updatedQuery.products = null
                }
                // check for invalid buying agency selection
                const selectedBuyingAgencyID = this.$store.getters.getAdsQuery?.buyingAgencies?.id
                let buyingAgencyExists = selectedBuyingAgencyID ? buyingAgencies?.some(item => item.id === selectedBuyingAgencyID) : false
                if (!buyingAgencyExists) {
                    updatedQuery.buyingAgencies = null
                }
                // check for invalid advertiser selection
                const selectedAdvertiserID = this.$store.getters.getAdsQuery?.advertisers?.id
                let advertiserExists = selectedAdvertiserID ? advertisers?.some(item => item.id === selectedAdvertiserID) : false
                if (!advertiserExists) {
                    updatedQuery.advertisers = null
                }
                this.$store.commit("setAdsQuery", updatedQuery)

                this.formFields.buyingAgencies.selectlistitems = buyingAgencies
                this.formFields.advertisers.selectlistitems = advertisers
                this.formFields.products.selectlistitems = products
                this.formFields.filmCode.buyingAgencies = buyingAgencies
                this.formFields.filmCode.advertisers = advertisers
                this.formFields.filmCode.products = products
                this.$store.commit(Mutations.setAdsFormFields, this.formFields)

                this.hasFetchedBuyingAgenciesAdvertisersProducts = false
            }
        },
        onEnter() {
            if (!this.disableRunBtn) this.submitSearch()
        },
        getTabTitleByIndex(index) {
            const tab = this.activeTabs.length > index ? this.activeTabs[index] : null
            return tab ? tab.title : null
        },
        findTabIndexByTitle(title) {
            return this.activeTabs.findIndex(tab => tab.title === title)
        },
    },
}
</script>

<style>
.body {
    background-color: white;
    padding: 20px 30px;
}
.totalRowsStyle {
    font-size: 11px;
    margin-left: 10px;
    margin-top: 8px;
}

.searchbutton {
    width: 8vw;
}
.label-text {
    font-weight: 713;
    font-size: 11px;
    color: #495057;
    float: left;
    margin-bottom: 0.35rem;
}
.nav-tabs {
    font-size: 80%;
    font-weight: 400;
    align-items: center;
}
.measure-header {
    text-align: right;
    line-height: 1.1;
}
</style>

<style scoped>
>>> .tooltip-inner {
    white-space: nowrap;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
